<template>
  <div id="app">
    <router-view />

    <div class="addStyle" v-html="aquireCSS"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      appTitle: "site/title",
    }),
  },

  watch: {
    appTitle() {
      this.setTitle();
    },
    $route (to, from){
      this.addCssForAquireChat(to, from)
    }
  },
  data(){
    return {
      aquireCSS: ''
    }
  },
  mounted() {
   this.addCssForAquireChat();
 },
  created() {
    this.setTitle();
  },

  methods: {
    addCssForAquireChat(){
      this.aquireCSS = ! ['login', 'register'].includes(this.$route.name) ? '<style> .aio-widget-frame,.acquire-launcher-wrapper{right:auto !important;left: 20px !important}.acquire-launcher-wrapper{left: 20px !important;width: 179px !important;}</style>' : ''
    },
    setTitle() {
      if (this.appTitle) {
        document.title = this.appTitle;
      }
    },
  },
};
</script>

<style>
#app {
  min-height: 100vh;
}
</style>
